export const groupPaths = {
  root: 'groups',
};
